<template>
    <div class="chat-body-upload" :class="{'active-back': isActiveBack, 'disabled-btn': isActiveTemplates}" v-if="isShowMedia && updateMessageData && updateMessageData.files.length" @click="toggleModal(true)">
        <span class="chat-body-upload__btn">
            <svg class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
        </span>
        <span class="chat-body-upload__icon-files">{{ updateMessageData.files.length }}</span>
    </div>
    <button type="button" class="chat-body-upload" :class="{'active-back': isActiveBack, 'disabled-btn': isActiveTemplates}" :aria-label="$t('Attach files')" v-else-if="isShowMedia" @click="toggleModal(true)">
        <span class="chat-body-upload__btn">
            <svg class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
        </span>
    </button>
    <Modal :show="isOpenUploadModal" :modalTitle="isEditFiles ? $t('Edit attachments') : $t('Attachments')" @close="toggleModal(false)" :modalClass="'chat-modal-media'">
      <template #header>
        <h4 class="modal-title">
          {{ isEditFiles ? $t('Edit attachments') : $t('Attachments') }}
          <span class="modal-title__count">{{ $t('{count} of {max}', { count: Math.max(filesCount || 0, filesLoad.length), max: 5 }) }}</span>
        </h4>
      </template>
      <template #body>
        <DragAndDrop
            ref="DragAndDropRef"
            :isSmallBtn="true"
            :max-files="5"
            :isImageProp="isImage"
            :maxSize="5"
            :allowedTypes="allowedTypes"
            :filesProp="filesLocal"
            :allreadyUploadedFiles="updateMessageData && updateMessageData.files.length ? updateMessageData.files : []"
            @files-count="filesCount = $event"
            @file-uploaded="onFileUploaded"
            @file-deleted="onFileDeleted"
        />
        <div class="chat-modal-media__form" :class="'file-' + filesLoad.length">
          <div class="chat-modal-media__form-input">
            <div contenteditable 
              class="chat-input"
              ref="chatModalInput"
              @paste="handlePaste"
              @input="checkPlaceholder"
              @keydown.enter.prevent="handleKeyDown"
              v-html="content"></div>
            <span class="chat-input__placeholder" v-if="inputPlaceholder">{{ $t("Add a comment...") }}</span>
          </div>
          <ChatFormBtns
              :isActiveBtn="allFilesUploaded"
              :contentMsg="contentMsg"
              :disableBtnSmile="disableBtnSmile"
              :isTablet="isTablet"
              :sendLabel="isEditFiles ? $t('Save') : $t('Send')"
              @add-emoji="addEmoji"
              @send-click="sendMessage"/>
        </div>
      </template>
    </Modal>
</template>
  
<script>
  import Modal from '/webpack-assets/vue/templates/chat/parts/ChatModal.vue';
  import DragAndDrop from '/webpack-assets/vue/components/DragAndDrop.vue';
  import EmojiPicker from './EmojiPicker.vue';
  import ChatFormBtns from './ChatFormBtns.vue';
  import { chatFetch } from './chatTokenManager';
  import axios from '/webpack-assets/vue/config/axios-config';

  export default {
    emits: ['updateText', 'addEmoji', 'closeEditReply', 'sendMessage', 'delete-files'],
    components: {
      Modal,
      DragAndDrop,
      EmojiPicker,
      ChatFormBtns
    },
    data() {
      return {
        files: [],
        filesLoad: [],
        filesCount: null,
        inputPlaceholder: true,
        content: '',
        isImage: true,
        isSending: false,
        allowedTypes: [
          'image/jpeg',
          'image/png',
          'text/plain',
          'application/pdf',
          'multipart/x-zip',
          'application/x-rar-compressed',
          'application/x-zip-compressed',
          'application/zip',
          'application/x-7z-compressed'
        ],
        disableBtnSmile: true,
        uploadQueue: [],
        isUploadingQueue: false,
        isOpenUploadModal: false,
        filesLocal: [],
      };
    },
    props: {
      miniChat: {
        type: Boolean,
        default: false
      },
      isShowMedia: {
        type: Boolean,
        default: true
      },
      isActiveBack: {
        type: Boolean,
        default: false
      },
      isActiveTemplates: {
        type: Boolean,
        default: false
      },
      isTablet: {
        type: Boolean,
        default: false
      },
      contentMsg: {
        type: String,
        default: ''
      },
      uuidList: {
        type: String,
        default: ''
      },
      updateMessageData: {
        type: Object,
        default: () => {}
      },
      filesProp: {
        type: Array,
        default: () => []
      },
      testUrlQuickChat: {
        type: String,
        default: ''
      },
      replyMsgId: {
        type: Number,
        default: null
      }
    },
    computed: {
        // Editing a sent message that already has files (design: "Edit attachments" / "Save")
        isEditFiles() {
            return !!(this.updateMessageData && this.updateMessageData.files && this.updateMessageData.files.length);
        },
      allFilesUploaded() {
        if(this.updateMessageData && this.updateMessageData.files.length){
            // const chatModalInput = this.$refs.chatModalInput;
            // return chatModalInput.innerText.trim() === ''
            return true
        } else {
            return this.filesLoad.length >= this.filesCount && this.filesLoad.length !== 0 && this.files.length === this.filesLoad.length && !this.isSending
        }
      }
    },
    watch: {
      filesProp(val) {
        if (val && val.length) {
          this.showUploadModal(val);
        }
      },
    },
    methods: {
        showUploadModal(files = []) {
            this.filesLocal = files && files.length ? Array.from(files) : [];
            this.toggleModal(true);
        },
        addEmoji(emoji) {
            this.$emit('add-emoji', emoji)
        },
        toggleModal(bool) {
            this.isOpenUploadModal = bool;

            if(bool) {
                this.disableBtnSmile = true;
                setTimeout(() => {
                    this.disableBtnSmile = false;
                }, 1000)
                this.$nextTick(() => {
                    const el = this.$refs.chatModalInput;
                    if (el) {
                        this.inputPlaceholder = this.contentMsg.trim() === '';
                        el.textContent = this.contentMsg;
                    }
                });
                
                if (this.updateMessageData && this.updateMessageData.files.length) {
                    // this.filesLoad = [...this.updateMessageData.files, ...this.filesLoad];
                    // this.files = [...this.updateMessageData.files, ...this.files];
                    //this.showUploadModal(this.updateMessageData.files);
                }
            } else {
                this.files = [];
                this.filesLoad = [];
                this.filesCount = null;
                this.disableBtnSmile = true;

                const el = this.$refs.chatModalInput;
                if (el) {
                    this.inputPlaceholder = true;
                    this.$emit('updateText', el.textContent);
                }
            }
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async onFileUploaded(fileObj) {
            if (fileObj.uploading) return;
            if (this.files.length >= 5) return;

            const exists = this.files.some(f =>
                f.name === fileObj.name &&
                f.size === fileObj.size &&
                f.file?.lastModified === fileObj.file.lastModified
            );
            if (exists) return;

            if(fileObj.uploadedId) {
                this.files.push(fileObj);
                this.filesLoad.push(fileObj);
                return
            }

            this.uploadQueue.push(fileObj);

            if (!this.isUploadingQueue) {
                this.processUploadQueue();
            }
        },
        async processUploadQueue() {
            this.isUploadingQueue = true;

            try {
                while (this.uploadQueue.length) {
                    const fileObj = this.uploadQueue.shift();

                    await this.uploadSingleFile(fileObj);
                    await this.delay(800);
                }
            } catch (error) {
                console.error('Queue error', error);
            } finally {
                this.isUploadingQueue = false;
            }
        },
        async uploadSingleFile(fileObj) {
            const localFile = {
            ...fileObj,
            uploading: true,
            uploadedId: null,
            };

            this.files.push(localFile);
            this.isSending = true;

            try {
            const formData = new FormData();
            formData.append('file', fileObj.file);

            const response = await chatFetch(
                `${this.testUrlQuickChat}message-file`,
                {
                method: 'POST',
                body: formData,
                }
            );

            const result = await response.json();

            if (result?.data?.id) {
                localFile.uploadedId = result.data.id;
                this.filesLoad = [...(this.filesLoad || []), result.data];
                fileObj.uploadedId = result.data.id;
                this.$refs.DragAndDropRef?.markFileUploaded(fileObj);
            } else {
                this.onFileDeleted(localFile.uploadedId);
                this.$refs.DragAndDropRef?.removePendingFile(localFile);
            }
            } catch (e) {
                this.onFileDeleted(localFile.uploadedId);
                this.$refs.DragAndDropRef?.removePendingFile(localFile);
                console.error('Upload error:', e);
            } finally {
                localFile.uploading = false;
                setTimeout(()=> {
                    this.isSending = false;
                }, 1000)
            }
        },
        async onFileDeleted(uploadedId) {
            this.filesCount = Math.max(0, this.filesCount - 1);
            this.files = this.files.filter(f => f.uploadedId !== uploadedId);
            this.filesLoad = Array.isArray(this.files)
            ? this.files
                .filter(f => Number.isInteger(Number(f?.uploadedId)))
                .map(f => Number(f.uploadedId))
            : [];

            //if(this.files.length === 0) this.toggleModal(false);

            this.$emit('delete-files', uploadedId);
            // const token = await getChatToken();
            // const response = await fetch(
            //     `${this.testUrlQuickChat}message-file?message_file_id=${uploadedId}`,
            //     {
            //         method: 'POST',
            //         headers: {
            //             Authorization: `Bearer ${token}`,
            //         }
            //     }
            // );

            // const result = await response.json();
            // console.log(result)
        },
        addEmoji(emoji) {
            const chatModalInput = this.$refs.chatModalInput;
            if (!chatModalInput) return;

            let currentText = chatModalInput.innerText || '';

            chatModalInput.innerText = currentText + emoji;
            this.inputPlaceholder = false;

            chatModalInput.focus();
            const range = document.createRange();
            const sel = window.getSelection();
            range.selectNodeContents(chatModalInput);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        },
        checkPlaceholder(evt) {
            const el = evt.target;
            if (!el) return;
            this.inputPlaceholder = el.innerText.trim() === '';
        },
        handlePaste(e) {
            const clipboardItems = e.clipboardData?.items;
            if (!clipboardItems) return;

            const files = [];

            for (const item of clipboardItems) {
            if (item.kind === 'file' && item.type.startsWith('image/')) {
                const file = item.getAsFile();
                if (file) files.push(file);
            }
            }
            if (files.length) {
            e.preventDefault();
            if (this.$refs.DragAndDropRef) {
                this.$refs.DragAndDropRef.addFiles(files);
            }
            }
        },
        handleKeyDown(event) {
            const isNotEmpty = event.target.innerText.trim() !== '';
            
            if (!isNotEmpty) return;

            if (event.shiftKey || (event.metaKey && event.key === 'Enter')) {
            document.execCommand('insertLineBreak');
            event.preventDefault();
            } else {
            this.sendMessage();
            }
        },
        async sendMessage() {
            const chatModalInput = this.$refs.chatModalInput;
            if (!chatModalInput) return;
            const msg = chatModalInput.innerText.trim();
            let url = '/chat-api/add-message';
            if (this.isSending || !chatModalInput) return;

            const uploadFilesIds = Array.isArray(this.files)
            ? this.files
                .filter(f => Number.isInteger(Number(f?.uploadedId)))
                .map(f => Number(f.uploadedId))
            : [];

            if (uploadFilesIds.length === 0) return;
            this.$emit('updateText', '');

            chatModalInput.innerText = '';
            this.inputPlaceholder = true;
            this.toggleModal(false);

            const payload = {
                file_ids: uploadFilesIds,
                conversation_uuid: this.uuidList,
            };

            if(this.replyMsgId && !this.updateMessageData) {
                payload.reply_to_id = this.replyMsgId;
            }

            if (msg && msg.trim()) {
                payload.text = msg.trim();
            }

            if (this.updateMessageData) {
                url = '/chat-api/update-message';
                payload.message_id = this.updateMessageData.id
            }
            this.$emit('close-edit-reply');
            try {
                const response = await axios.post(url, payload, {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }
                );
            } catch (error) {
                console.error('Error sending message:', error);
            } finally {
                this.isSending = false;
                this.filesLoad = [];
                this.files = [];
            }
        },
    },
  };
  </script>
  
<style lang="scss" scoped>
    .chat-body-upload{
        width: 32px;
        height: 32px;
        min-width: 32px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        margin: 0;
        padding: 0;
        background: transparent;
        color: inherit;
        transition: 0.2s;
        position: relative;
        z-index: 2;
        cursor: pointer;
        @media only screen and (max-width: 1023px) {
            width: 36px;
            height: 36px;
            min-width: 36px;
        }
        &__icon-files{
            position: absolute;
            right: 2px;
            top: 2px;
            z-index: 3;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            box-sizing: border-box;
            border-radius: 8px;
            background-color: #2F6BE6;
            color: var(--wc-on-accent);
            font-family: var(--wc-font-bold);
            font-size: 10px;
            line-height: 16px;
            text-align: center;
            pointer-events: none;
        }
        &__btn{
            background-color: transparent;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.2s;
            border-radius: 8px;
            svg{
                width: 18px;
                height: 18px;
            }
        }
        &.disabled-btn{
            cursor: not-allowed;
            opacity: 0.5;
            pointer-events: none;
        }
        &:has(.chat-body-upload__icon-files) .chat-body-upload__btn{
            background-color: var(--wc-accent-soft);
            color: var(--wc-accent);
        }
        &:hover .chat-body-upload__btn{
            @media only screen and (min-width: 992px) {
                background-color: var(--wc-bg);
            }
        }
    }
</style>

<style lang="scss">
    .chat-modal-media{
        .modal-title__count{
            margin-left: 8px;
            font-family: var(--wc-font);
            font-size: 13px;
            line-height: 18px;
            color: var(--wc-text-3);
        }
        .modal-body{
            padding: 12px 20px 20px;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
        &__form{
          //margin-top: 30px;
          background-color: var(--wc-surface);
          border: 1px solid var(--wc-border);
          padding: 6px 6px 6px 12px;
          border-radius: 12px;
          display: flex;
          align-items: flex-end;
          gap: 2px;
          &:focus-within{
            border-color: var(--wc-accent-border);
          }
          .chat-body-form-btn__emoji-wrap{
            max-height: 210px;
          }
          &.file-2{
            .chat-body-form-btn__emoji-wrap{
                max-height: 270px;
            }
          }
          &.file-3,
          &.file-4,
          &.file-5{
            .chat-body-form-btn__emoji-wrap{
                max-height: 340px;
            }
          }
          &-input{
            flex-grow: 1;
            margin-right: 10px;
            position: relative;
            .chat-input{
              touch-action: manipulation;
              width: 100%;
              font-family: "Roboto-Regular", sans-serif;
              font-weight: 400;
              overflow-y: auto;
              font-size: 14px;
              line-height: 1.4;
              color: var(--wc-text);
              max-height: 150px;
              -webkit-user-modify: read-write-plaintext-only;
              user-modify: read-write-plaintext-only;
              padding: 0;
              outline: none;
              white-space: pre-wrap;
              word-break: break-word;
              @media only screen and (max-width: 767px) {
                font-size: 16px;
              }
              &__placeholder{
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                font-family: "Roboto-Regular", sans-serif;
                font-weight: 400;
                font-size: 14px;
                line-height: 1.4;
                color: var(--wc-text-3);
                pointer-events: none;
              }
            }
          }
          &-btns{
            display: flex;
            align-items: center;
            gap: 10px;
            &-smile{
              cursor: pointer;
              display: flex;
              align-items: center;
              position: relative;
              padding-right: 10px;
              height: 24px;
                background-color: var(--wc-surface);
                border-radius: 100%;
                height: 30px;
                min-width: 30px;
              &::after{
                  z-index: 1;
                  position: absolute;
                  bottom: 0;
                  height: 60px;
                  width: 60px;
                  right: 0;
                  background-color: transparent;
                  content: '';
                  pointer-events: none;
              }
              .svg path{
                  transition: 0.4s;
              }
              &-wrap{
                  box-shadow: 5px 5px 15px 0px var(--wc-shadow-strong);
                  position: absolute;
                  background-color: var(--wc-surface);
                  border-radius: 8px;
                  padding: 10px;
                  pointer-events: none;
                  opacity: 0;
                  z-index: 10;
                  bottom: 35px;
                  right: -10px;
                  transition: 0.4s;
                  max-height: 340px;
                  overflow-y: auto;
              }
              &:hover{
              &::after,
                  .chat-modal-media__form-btns-smile-wrap{
                      opacity: 1;
                      pointer-events: all;
                  }
                  .svg path{
                      fill: var(--wc-text);
                  }
              }
            }
            .chat-btn-send{
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: var(--wc-surface-2);
              border-radius: 100%;
              width: 32px;
              height: 32px;
              padding: 2px 2px 0 0;
              opacity: 0.5;
              pointer-events: none;
              &.active{
                opacity: 1;
                pointer-events: all;
              }
            }
          }
        }
    }
  </style>